"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 导出失败的 Icon
 * url: https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/97301743-6842-4db2-a9e0-7f78bffc30c1
 * name: MIcSettingsSpace
 */
function MIcSettingsSpace() {
    return null;
}
exports.default = MIcSettingsSpace;
;
